"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollStaticContentStatisticItemTagsEnum = void 0;
exports.PollStaticContentStatisticItemTagsEnum = {
    _1: 'severity-level-1',
    _2: 'severity-level-2',
    _3: 'severity-level-3',
    _4: 'severity-level-4',
};
//# sourceMappingURL=poll-static-content-statistic-item.js.map